import appConfig from '../../config'

// MI6's Cloudinary cloud, which doclet images are uploaded to. DocletPage takes
// it as a prop (src/doclets doesn't read app config).
export const CLOUDINARY_NAME: string | null = appConfig.CLOUDINARY_NAME || null
